import {
  ListTriggersResponse,
  GetEligibleTriggersResponse,
} from './src/service-plugins-types.js';
import {
  ListTriggersEnvelope,
  GetEligibleTriggersEnvelope,
} from './src/interfaces-ecommerce-v1-custom-trigger.public.js';

export * from './src/service-plugins-types';
export { ListTriggersEnvelope, GetEligibleTriggersEnvelope };

/**
 * Lists all custom triggers provided by your service plugin integration.
 *
 * This method is automatically called by Wix eCommerce to populate the custom [minimum requirements section of an automatic discount](https://support.wix.com/en/article/wix-stores-creating-automatic-discounts#:~:text=Create%20minimum%20requirements).
 */
export declare function listTriggers(
  payload: ListTriggersEnvelope
): ListTriggersResponse | Promise<ListTriggersResponse>;
/**
 * Retrieves eligible custom discount triggers based on the provided items.
 *
 * This method is automatically called by Wix eCommerce to retrieve the custom discount triggers provided by your extension.
 * This happens when actions are performed on the cart and checkout entities/pages. For example, when an item is added to the cart.
 */
export declare function getEligibleTriggers(
  payload: GetEligibleTriggersEnvelope
): GetEligibleTriggersResponse | Promise<GetEligibleTriggersResponse>;
